/**
 * @generated SignedSource<<069e3238b0cf5a779abd76e207ac7b54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuPriceRanges_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentType": "SbSharedRefineMenuPriceRanges_user";
};
export type SbSharedRefineMenuPriceRanges_user$key = {
  readonly " $data"?: SbSharedRefineMenuPriceRanges_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuPriceRanges_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuPriceRanges_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5f28254e4fdc4994adaee2f3f6380047";

export default node;
